module.exports = __webpack_public_path__ + "media/images/advertising-log-nav-5aba64381b84fa54c24b95972fec0d7c.svg";